import type { SEOPropsType } from '..';

export const SEO_NIACINAMIDE_CONTENT: SEOPropsType = {
  title: 'Niacinamide Prescription - Curology Custom Formula',
};
